// Duration formatting shared by the server and the client bundle (RD §3.14). Dependency-free.

const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;

/** "Xh Ym", rounded to the nearest minute. 0 → "0h 0m"; 59 s → "0h 1m"; 3599 s → "1h 0m". */
export function formatDurationHm(totalSeconds: number): string {
  const safe = Number.isFinite(totalSeconds) && totalSeconds > 0 ? totalSeconds : 0;
  const totalMinutes = Math.round(safe / SECONDS_PER_MINUTE);
  const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
  const minutes = totalMinutes % MINUTES_PER_HOUR;
  return `${hours}h ${minutes}m`;
}
